import { IconCalendarCheck, IconCheck, IconClock, IconEdit, IconMapPin, IconUser, IconX } from "../icons/IconsMedico";
import { BadgeEstado, formatFechaHora } from "../utils/MedicoUtils";
import "./TurnoCardMedico.css";

const TurnoCardMedico = ({ turno, acciones = false, onVerPaciente, onConfirmar, onMarcarRealizado, onCancelar, onEditar }) => (
    <div className={`turno-card${acciones ? " turno-card--activo" : ""}`}>
        <div className="turno-card__header">
            <div className="turno-card__avatar">{turno.paciente ? turno.paciente.charAt(0) : "–"}</div>
            <div className="turno-card__info">
                <p className="turno-card__medico">
                    {turno.paciente ?? <span className="turno-card__sin-paciente">Sin paciente asignado</span>}
                </p>
                <p className="turno-card__especialidad">
                    <IconMapPin /> {turno.sede}
                </p>
            </div>
            <BadgeEstado estado={turno.estado} />
        </div>

        <div className="turno-card__meta">
            <span>
                <IconClock style={{ width: 16, height: 16 }} /> {formatFechaHora(turno.fechaHora)}
            </span>
            <span>
                <IconUser /> {turno.duracion} min · ${turno.costo.toLocaleString("es-AR")}
            </span>
        </div>

        {acciones && (
            <div className="turno-card__actions">
                {turno.paciente && (
                    <button
                        className="btn-ghost btn-ghost--patient"
                        onClick={() => onVerPaciente?.({
                            nombre: turno.paciente,
                            id: turno.pacienteId,
                            raw: turno.pacienteRaw,
                        })}
                    >
                        <IconUser /> Ver paciente
                    </button>
                )}
                <div className="turno-card__actions-right">
                    {turno.estado === "reservado" && (
                        <button
                            className="btn-ghost btn-ghost--confirm"
                            aria-label="Confirmar turno"
                            onClick={() => onConfirmar?.(turno)}
                        >
                            <IconCheck /> Confirmar
                        </button>
                    )}
                    {(turno.estado === "confirmado" || turno.estado === "reservado") && (
                        <>
                            <button
                                className="btn-ghost btn-ghost--success"
                                aria-label="Marcar turno como realizado"
                                onClick={() => onMarcarRealizado?.(turno)}
                            >
                                <IconCalendarCheck /> Realizado
                            </button>
                            <button
                                className="btn-ghost btn-ghost--danger"
                                aria-label="Cancelar turno"
                                onClick={() => onCancelar?.(turno)}
                            >
                                <IconX /> Cancelar
                            </button>
                        </>
                    )}
                    <button
                        className="btn-ghost"
                        aria-label="Editar turno"
                        onClick={() => onEditar?.(turno)}
                    >
                        <IconEdit /> Editar
                    </button>
                </div>
            </div>
        )}
    </div>
);

export default TurnoCardMedico;